import { useTranslation } from 'react-i18next';

interface TodaySummaryCardProps {
  deliveries: number;
  earnings: number;
  avgTime: number;
  dailyGoal: number;
}

export default function TodaySummaryCard({ deliveries, earnings, avgTime, dailyGoal }: TodaySummaryCardProps) {
  const { t } = useTranslation();
  const progress = Math.min((deliveries / dailyGoal) * 100, 100);
  
  return (
    <div className="bg-white rounded-2xl p-5 shadow-md">
      <h3 className="text-base font-bold text-gray-900 mb-4">
        {t('todaysSummary')}
      </h3>
      
      <div className="grid grid-cols-3 gap-4 mb-5">
        <div className="text-center">
          <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-xl mx-auto mb-2">
            <i className="ri-box-3-line text-xl" style={{ color: '#006491' }}></i>
          </div>
          <p className="text-2xl font-bold text-gray-900 mb-0.5">{deliveries}</p>
          <p className="text-xs text-gray-600">{t('deliveries')}</p>
        </div>
        
        <div className="text-center">
          <div className="w-12 h-12 flex items-center justify-center bg-green-50 rounded-xl mx-auto mb-2">
            <i className="ri-money-dollar-circle-line text-xl text-green-600"></i>
          </div>
          <p className="text-2xl font-bold text-gray-900 mb-0.5">{earnings}</p>
          <p className="text-xs text-gray-600">SEK</p>
        </div>
        
        <div className="text-center">
          <div className="w-12 h-12 flex items-center justify-center bg-purple-50 rounded-xl mx-auto mb-2">
            <i className="ri-time-line text-xl text-purple-600"></i>
          </div>
          <p className="text-2xl font-bold text-gray-900 mb-0.5">{avgTime}</p>
          <p className="text-xs text-gray-600">{t('avgTime')}</p>
        </div>
      </div>
      
      <div className="pt-4 border-t border-gray-100">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-semibold text-gray-700">
            {t('dailyGoal')}: {dailyGoal} {t('deliveries')}
          </p>
          <p className="text-sm font-bold" style={{ color: '#E31837' }}>
            {deliveries}/{dailyGoal}
          </p>
        </div>
        
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{ 
              width: `${progress}%`,
              backgroundColor: '#E31837'
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
